/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPictureInPictureTopFilled = createReactComponent("filled", "picture-in-picture-top-filled", "IconPictureInPictureTopFilled", [["path", { "d": "M11 4a1 1 0 0 1 0 2h-6a1 1 0 0 0 -1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1 -1v-4a1 1 0 0 1 2 0v4a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3z", "key": "svg-0" }], ["path", { "d": "M20 4a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-5a2 2 0 0 1 -2 -2v-3a2 2 0 0 1 2 -2z", "key": "svg-1" }]]);

export { IconPictureInPictureTopFilled as default };
//# sourceMappingURL=IconPictureInPictureTopFilled.mjs.map
